module.exports = __webpack_public_path__ + "media/images/riders/PAULINE_FERRAND_PREVOT-e88680f3c731b71ae0313829909721d7.png";